export default class UpdateDocumentRequest {
    date: string;
    file: string;

    constructor(date: string, file: string) {
        this.date = date;
        this.file = file;
    }
}
